/**
 * Null-safe string comparator using locale-aware ordering.
 * Treats null/undefined as empty string so rows with missing data sort to the top.
 * Intended for use in DataGrid column `compare` callbacks.
 */
export const compareString = (a: string | null | undefined, b: string | null | undefined): number =>
  (a ?? '').localeCompare(b ?? '');

/**
 * Null-safe numeric comparator.
 * Treats null/undefined as 0 so rows with missing data sort to the top.
 * Intended for use in DataGrid column `compare` callbacks.
 */
export const compareNumber = (a: number | null | undefined, b: number | null | undefined): number =>
  (a ?? 0) - (b ?? 0);

/**
 * Tier comparator that orders by program importance rather than alphabetically:
 * Authorized < Silver < Gold < Platinum.
 * Case-insensitive; null/undefined/unknown values sort before known tiers.
 * Intended for use in DataGrid column `compare` callbacks on tier columns.
 */
const TIER_RANK: Record<string, number> = {
  authorized: 1,
  silver: 2,
  gold: 3,
  platinum: 4,
};

export const compareTier = (a: string | null | undefined, b: string | null | undefined): number => {
  const rankA = TIER_RANK[(a ?? '').trim().toLowerCase()] ?? 0;
  const rankB = TIER_RANK[(b ?? '').trim().toLowerCase()] ?? 0;
  if (rankA !== rankB) return rankA - rankB;
  return (a ?? '').localeCompare(b ?? '');
};
